/* src/app/private/components/whatsapp-config/delete-whatsapp-config/delete-whatsapp-config.component.scss */
/*# sourceMappingURL=delete-whatsapp-config.component.css.map */
